import AnimateHeight from "react-animate-height";
import React from "react";
import classnames from "classnames";

import { KeyboardArrowDown } from "./icons/KeyboardArrowDown";

interface AccordionItemProps {
  label: JSX.Element | string;
  expanded?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  duration?: number;
  noArrow?: boolean;
  arrowText?: string;
  hack?: "footer"; // TODO: refactor to replaceClasses
}

export const AccordionItem = (props: AccordionItemProps) => {
  const isFooter = props.hack === "footer";
  const chveronClass = classnames("transition-transform duration-300 absolute w-5 h-5 tablet:w-6 tablet:h-6", {
    "rotate-180": props.expanded,
    "right-4": !isFooter,
    "right-0": isFooter,
  });

  let containerClass = "";
  if (props.noArrow) {
    containerClass = classnames(
      "relative flex items-center justify-between overflow-hidden cursor-pointer select-none py-4 px-5 txt-body-mobile-12sb tablet:txt-body-16sb",
      {
        "bg-off-white text-off-black": !props.expanded,
        "bg-background text-label": props.expanded,
      }
    );
  } else {
    containerClass = classnames(
      "relative flex items-center overflow-hidden cursor-pointer select-none text-off-black py-4",
      {
        "px-5 bg-off-white txt-field-description tablet:txt-body-16": !isFooter,
        "txt-body-14": isFooter,
      }
    );
  }
  return (
    <>
      <div className={containerClass} onClick={props.onClick}>
        {props.label}
        {!props.noArrow ? <KeyboardArrowDown className={chveronClass} /> : null}
        {props.arrowText ? (
          <div className="text-label txt-body-mobile-12 tablet:txt-body-14">{props.arrowText}</div>
        ) : null}
      </div>
      <AnimateHeight duration={props.duration ?? 300} height={props.expanded ? "auto" : 0}>
        {props.children}
      </AnimateHeight>
    </>
  );
};
